export default function videos(state = [], action) {
 switch (action.type) {
  case "ADD_VIDEO":
   return Object.assign({}, state, action.video);

  default:
   return state;
 }
}
